import React, { useRef } from 'react'
import { PiPlus } from 'react-icons/pi'
import { FBPage } from 'components/FbUI/Page/FBPage'
import {
  FBPageEyebrow,
  FBPageHeader,
  FBPageTableContainer,
  FBPageTitle,
  FBPageTitleRow,
} from 'components/FbUI/Page/styles'
import FbButton from 'components/FbUI/FbButton'
import {
  BrandsTable,
  type BrandsTableHandle,
} from 'components/Tables/BrandsTable/BrandsTable'
import { TableLinkStyleProvider } from 'components/Tables/CommonTableCells/TableLinkStyleContext'
import { ToolbarDensityProvider } from 'components/Tables/CommonTableCells/ToolbarDensityContext'
import { WorkspaceOutlineIcon } from 'components/Layout/LeftNav/nav-icons'
import { PinToHomepageButton } from 'components/QuickAccess/PinToHomepageButton'
import { useRecordVisit } from 'components/QuickAccess/useRecordVisit'
import { PAGE_KEYS } from 'services/homepage'

/** Brand management page accessible from Workspace nav. */
export const BrandsPage: React.FC = () => {
  useRecordVisit({ targetType: 'page', pageKey: PAGE_KEYS.brands })
  const tableRef = useRef<BrandsTableHandle>(null)
  return (
    <FBPage
      // Tighter outer padding matching the other DS2026 table pages so the
      // table gets more height; global --page-*-padding vars left untouched.
      innerPageClassName="!bg-surface-page !p-[8px]"
      containerClassName="!bg-surface-page !shadow-none !px-[16px] !py-[12px]"
    >
      <FBPageHeader className="!mb-6">
        <FBPageTitleRow>
          <div className="flex flex-col items-start">
            <FBPageEyebrow>
              <WorkspaceOutlineIcon size={14} />
              Workspace
            </FBPageEyebrow>
            <FBPageTitle className="!text-fg">Brands</FBPageTitle>
          </div>
          <div className="ml-auto flex items-center gap-2">
            <FbButton
              className="!bg-brand-bright !text-white hover:!bg-brand-active"
              onClick={() => tableRef.current?.openCreateModal()}
            >
              <PiPlus size={16} />
              Create Brand
            </FbButton>
            <PinToHomepageButton
              target={{ targetType: 'page', pageKey: PAGE_KEYS.brands }}
            />
          </div>
        </FBPageTitleRow>
      </FBPageHeader>

      <TableLinkStyleProvider variant="plain">
        <FBPageTableContainer
          className="flex-col overflow-hidden rounded-lg border border-neutral-200 bg-white shadow-[0px_1px_3px_0px_rgba(16,24,40,0.08),0px_1px_2px_-1px_rgba(16,24,40,0.04)]"
          style={{
            height: 'calc(var(--base-page-table-height) - 10px)',
          }}
        >
          {/* sm toolbar density (32px search), matching the other table pages. */}
          <ToolbarDensityProvider value="sm">
            <BrandsTable ref={tableRef} tableKey="brands-page-table" />
          </ToolbarDensityProvider>
        </FBPageTableContainer>
      </TableLinkStyleProvider>
    </FBPage>
  )
}
